import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=7e4e5c6b&scoped=true&lang=pug&"
import script from "./coming-soon.vue?vue&type=script&lang=js&"
export * from "./coming-soon.vue?vue&type=script&lang=js&"
import style0 from "./coming-soon.vue?vue&type=style&index=0&id=7e4e5c6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e5c6b",
  null
  
)

export default component.exports